import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const homeData: NavItem[] = [
  {
    label: 'Intro',
    to: '/pages/home/intro'
  },
  {
    label: 'Partners',
    to: '/pages/home/partners'
  },
  {
    label: 'About',
    to: '/pages/home/about'
  },
  {
    label: 'Client',
    to: '/pages/home/client'
  },
  {
    label: 'Community',
    to: '/pages/home/community'
  },
  {
    label: 'News',
    to: '/pages/home/news'
  },
  {
    label: 'Report',
    to: '/pages/home/report'
  },
  {
    label: 'FAQ',
    to: '/pages/home/faq'
  }
];
